import React, { ReactNode } from "react";
import { Switch } from "react-router-dom";
import ValidatorRouteWrapper from "./ValidatorRouteWrapper";

/**
 * Props for the ValidatorSwitchWrapper component.
 */
interface ValidatorSwitchWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component for validating routes and rendering child components within a Switch.
 * It wraps each child Route component with the ValidatorRouteWrapper component.
 */
export const ValidatorSwitchWrapper = ({ children }: ValidatorSwitchWrapperProps) => {
  const wrappedChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      const { path } = child.props;
      return (
        <ValidatorRouteWrapper exact path={path}>
          {child}
        </ValidatorRouteWrapper>
      );
    }
    return child;
  });

  return <Switch>{wrappedChildren}</Switch>;
};
